import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          box-shadow: 0 2px 4px ", ";\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          border: 1px solid ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      padding: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  color: ", ";\n  flex-shrink: 0;\n  margin: 0;\n  ", "\n\n  overflow: hidden;\n  position: relative;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { color, property, size } from '@scp/ui-shared/theme/variables';
import { getCSSUnitValue } from '@scp/ui-shared/theme/utils';
var StyledPaper = styled.div(_templateObject(), function (props) {
  return props.secondary ? color.backgroundSecondary : color.background;
}, property.borderRadius, color.textPrimary, function (props) {
  return !!props.padding && css(_templateObject2(), getCSSUnitValue(props.padding));
}, function (props) {
  return !props.withShadow ? !props.noBorder && css(_templateObject3(), color.border) : css(_templateObject4(), rgba(color.palette.black, 0.35));
});
/**
 * A Paper component that's used to wrap the content into bordered boxes
 *
 * @example ./__docs__/Paper.md
 */

export var Paper = forwardRef(function (_a, ref) {
  var _a$padding = _a.padding,
      padding = _a$padding === void 0 ? size.gutterSmall : _a$padding,
      _a$as = _a.as,
      asElement = _a$as === void 0 ? 'div' : _a$as,
      _a$withShadow = _a.withShadow,
      withShadow = _a$withShadow === void 0 ? false : _a$withShadow,
      otherProps = __rest(_a, ["padding", "as", "withShadow"]);

  return React.createElement(StyledPaper, Object.assign({
    ref: ref,
    as: asElement,
    padding: padding,
    withShadow: withShadow
  }, otherProps));
});